
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {instrumentApi} from "@/api/instrument";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import {IPage} from "@/js/page";
    import {userApi} from "@/api/organization";
    import {debounced} from "@/common/public";
    import {Param} from "@/js/ParamList";

    const {checkTypeList} = require("@/js/checkType");

    @Component({
        components: {TableShowRangeHead,TableShowRangeBody, SetTableColumns}
    })
    export default class InstrumentList extends Vue {
        private debouncedUse = debounced.use(this.handleClick, 600)
        listData = [] as any;
        listParam: IPage = {
            size: 500,
            current: 1,
        };
        surveyRangesDialog = {
            visible: false,
            paramList: [] as Param[]
        }
        listTotal = 0;
        tabCol = [];
        allSelected = [] as any;
        screenHeight = document.documentElement.clientHeight;
        load = false;
        @Prop() private propOption!: any;
        @Prop() private propParams!: any;

        created() {
            this.getConfig();
        }
        @Watch("propParams")
        getpropParams(n: any, o: any) {
            if(JSON.stringify(n) != JSON.stringify(o)){
                if (this.propParams.isAudit || this.propParams.isInspection) {
                    this.loadData();
                } else {
                    this.refresh();
                }
            }
        }
        openSurveyRangesDialog(surveyRanges: string) {
            this.surveyRangesDialog.paramList = this.parseParamList(surveyRanges);
            this.surveyRangesDialog.visible = true;
        }
        closeSurveyRangesDialog() {
            this.surveyRangesDialog.paramList = [] as Param[];
            this.surveyRangesDialog.visible = false;
        }
        getConfig() {
            userApi.getUserConfig({name: "InstrumentMiniPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                }
            })
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        handleClick() {
            this.allSelected = [];
            let $table = this.$refs.pltable as HTMLFormElement;
            $table.clearSelection();
            this.loadData();
        }
        showTooltip(row: any){
            if(this.propOption.addAudit && (row.strong == 0 || row.purposeCode == "9")){
                row.showTooltip = true;
            }
            if(this.propOption.showSelectInspection && this.checkboxInit3Title(row) != ""){
                row.showTooltip = true;
            }
        }
        hideTooltip(row: any) {
            row.showTooltip = false;
        }
        loadData() {
            const params = {
                ...this.propParams,
                ...this.listParam,
            }
            if(params.checkType === "" || params.checkType === undefined){
                params.checkType = params.checkType2;
            }
            this.load = true;
            let api = instrumentApi.list(params);
            api.then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                    this.load = false;
                    let $table = this.$refs.pltable as HTMLFormElement;
                    $table.reloadData(this.listData);
                    this.$nextTick(() => {
                        this.checkThisPageData();
                    })
                }
            })
        }

        checkThisPageData() {
            let $table = this.$refs.pltable as HTMLFormElement;
            this.listData.forEach((e: any) => {
                const index = this.allSelected.findIndex((e2: any) => e2.instrumentId == e.instrumentId);
                if (index != -1 && !this.allSelected[index].id) {
                    this.allSelected.splice(index, 1, e);
                    $table.toggleRowSelection([
                        {
                            row: e,
                            selected: true
                        }
                    ]);
                }
            })
        }
        parseParamList(jsonString: string){
            if(jsonString){
                return JSON.parse(jsonString);
            }

        }
        memberSelectAll(selections: any) {
            this.memberSelect(selections);
        }

        memberSelect(selections: any) {
            let allSelected = [];
            if(this.propOption && this.propOption.showSelectInspection && selections.length > 0){
                const selected = selections[0];
                const flag = this.mutexCheck(selected.checkResult.value, selected.checkType)
                allSelected = selections.filter((row: any) => flag === this.mutexCheck(row.checkResult.value, row.checkType));
            }else{
                allSelected = selections;
            }
            this.allSelected = allSelected;
            let $table = this.$refs.pltable as HTMLFormElement;
            $table.clearSelection();
            allSelected.forEach((row: any) => {
                $table.toggleRowSelection([
                    {
                        row: row,
                        selected: true
                    }
                ]);
            });
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.pltable as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
            });
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.listParam.current = 1;
            this.loadData();
            userApi.updateUserConfig({name: "InstrumentMiniPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadData();
        }

        detail(data: any) {
            let id = data.id;
            this.$router.push("/qj/instrument/detail/2/" + id);
        }

        showCheckTypeStr(e: any) {
            let str = "";
            const obj = checkTypeList.find((e2: any) => e2.id == e.checkType);
            if (obj) {
                str = obj.name;
            } else {
                str = '-';
            }
            return str;
        }

        refresh() {
            this.listParam.current = 1;
            this.debouncedUse();
        }

        checkboxInit2(row: any,index: number){
            if(row.strong == 1 && row.purposeCode != "9"){
                return 1;//0不可勾选
            }else{
                return 0;//1可勾选
            }
        }

        checkboxInitInspection(row: any,index: number){
            //备案状态:已接收 2，检定状态：已检定，已超期，未检定  1,5,0  自动分配
            //已接收 2，  未受理 3     选检测机构
            //免备案 5，  已检定，已超期，未检定 1,5,0   选检定机构
            //免备案 5，  未受理 3   选检定机构
            let r = 1;
            if(this.allSelected && this.allSelected.length > 0){
                const selected = this.allSelected[0] as any;
                const checkR = selected.checkResult.value;
                const checkType = selected.checkType;
                if(this.mutexCheck(checkR, checkType) !== this.mutexCheck(row.checkResult.value, row.checkType)){
                    r = 0;
                }
            }
            return r;
        }
        //互斥勾选判断
        mutexCheck(checkResult: number, checkType: number){
            let type = 0;
            if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 2){
                type = 1;
            }else if(checkResult === 3 && checkType === 2){
                type = 2;
            }else if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 5){
                type = 3;
            }else if(checkResult === 3 && checkType === 5){
                type = 4;
            }
            return type;
        }

        checkboxInit2Title(e:any){
            let str = "";
            if(e.strong == 0 && e.purposeCode != "9"){
                str = "不允许勾选不在强检计量器具目录内的器具";
            }else if(e.strong != 0 && e.purposeCode == "9"){
                str = "不允许勾选不符合强检计量器具规定用途的器具";
            }else if(e.strong == 0 && e.purposeCode == "9"){
                str = "不允许勾选不在强检计量器具目录内，或不符合强检计量器具规定用途的器具";
            }
            return str;
        }
        // 检定器具不允许勾选的提示
        checkboxInit3Title(row:any){
            let str = "";
            if(this.allSelected && this.allSelected.length > 0){
                const selected = this.allSelected[0] as any;
                str = "计量器具报检时，是否允许同时报检与计量器具的“备案状态”和“检定状态”有关";
            }
            return str;
        }
        toggleSelection(rows: any) {
            let $table = this.$refs.pltable as HTMLFormElement;
            if (rows) {
                rows.forEach((row: any) => {
                    $table.toggleRowSelection([
                        {
                            row: row,
                            selected: true
                        }
                    ]);
                });
            } else {
                $table.clearSelection();
            }
            this.allSelected = rows;
        }

        getCheckId() {
            const ids = this.allSelected.flatMap((e: any) => e.id);
            return ids;
        }

        getCheckData(callback: any) {
            if(callback){
                callback(this.allSelected);
            }
        }
    }
